import { render, staticRenderFns } from "./SpeakersCount.vue?vue&type=template&id=1a8ad610"
import script from "./SpeakersCount.vue?vue&type=script&lang=js"
export * from "./SpeakersCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports